<div class="modal-content">
  <div class="div-message-box animated fadeIn fast ng-scope">
    <div class="message-box-container animated fadeIn fast">
      <!--     {{ctrl.modalName}} -->

      <div class="message-box-middle">
        <!-- Loading Spinner -->
        @if (crudLoading) {
<div class="loading-section">
          <i class="fa fa-spinner fa-spin"></i>
          <span class="loading-text"></span>
        </div>
}
        @if (!crudLoading) {
<div>
          <span class="msg-title ng-binding"
            ><i class="fa fa-sign-out txt-color-orange-dark"></i>Confirm
          </span>
          <p class="p-text ng-binding">
            Are you sure you want to run the batch allocation for selected
            entities?
          </p>
          <div class="message-box-button-section">
            <button
              class="btn btn-default btn-xs"
              id="switch-no"
              (click)="cancel()"
            >
              No
            </button>
            <button
              class="btn btn-danger btn-xs"
              id="switch-yes"
              (click)="confirmBatchAllocate()"
            >
              Yes
            </button>
          </div>
        </div>
}
      </div>
    </div>
  </div>
</div>
